import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';
import ContentMenuCard from "../ContentMenuCard";
import LoadingButton from "../../../Loading/LoadingButton";

import contentNewfolder from "../../../contentImgs/blended-learning.png";
import Snackbar from "../../../../Snackbar";
import { createNewFolder } from "../../../../store/actions/CreateContent/FolderAPI/FolderAPIs";
import Loading from "../../../Loading/Loading";
import { createNewMilestone } from "../../../../store/actions/CreateContent/OrganizeAPI/SubCoursesAPIs";
import { createNewSection } from "../../../../store/actions/CreateContent/FolderAPI/SectionAPI";
import AddSkillsSection from "./AddSkillSection";
import { getAllChaptersBySectionId } from "../../../../store/actions/CreateContent/FolderAPI/ChapterAPI";
const CreateSectionPopup =({mileStoneItem,menuOrder,sendBackItem,changeItemData,sectionItem,setNewSectionPopUp})=>{

     const dispatch = useDispatch();
     
        const [snackbarVisible, setSnackbarVisible] = useState(false);
        const [snackbarColor, setSnackbarColor] = useState("#958FDA");
        const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
      
      const showSnackbar = () => {
        setSnackbarVisible(true);
      };
     
      const hideSnackbar = () => {
        setSnackbarVisible(false);
      };

      const [sectionName ,setSectionName] =useState(sectionItem?.Name?sectionItem?.Name:"");
     
      const [sectionDescription ,setSectionDescription] =useState(sectionItem?.Description?sectionItem?.Description:"")
      const [sectionID ,setSectionID] =useState(sectionItem?.ID?sectionItem?.ID:"");
      const [sectionMenuOrder ,setSectionMenuOrder] =useState(sectionItem?.menuOrder?sectionItem?.menuOrder:menuOrder);
      const [showAddFolderEdit ,setShowAddFolderEdit] =useState(sectionItem?.ID?true:false)
       
     const [FolderLook ,setFolderLook] =useState("")
           
           
 const [sectionFAQs ,setSectionFAQs] =useState(sectionItem?.FAQs?JSON.parse(sectionItem?.FAQs):[]);
 const [sectionSkills ,setSectionSkills] =useState(sectionItem?.Skills?JSON.parse(sectionItem?.Skills):[]);
            const [loader , setLoader] =useState({status:false});
      
       const [animate, setAnimate] = useState(false);
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        



      
       const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     
          
                  const appId = useSelector((state)=>state?.app?.app?.ID);
                  const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
       useEffect(() => {
         // Trigger the animation after a delay (e.g., 500ms)
         const timer = setTimeout(() => {
          setAnimate(true);  
        }, 100);
      
         return () => clearTimeout(timer); // Cleanup on unmount
       }, []);
      useEffect(()=>{
        // setCourseTitleData();
      },[])
      
      
const handleCreateSection=(e)=>{

    let editType="",SkillsData="",FAQsData="";
    // console.log(sectionSkills)
   
      SkillsData=JSON.stringify(sectionSkills);
      FAQsData=JSON.stringify(sectionFAQs);
     

setLoader({status:true});
// console.log({Name:sectionName,Description:sectionDescription,Skills:SkillsData,
//     FAQs:FAQsData,
//     token:AppToken,courseId:postIdCourse ,postParent:mileStoneItem?.ID,userEmail:user_email?user_email:null,
//     currentToken:currentToken?currentToken:null,appToken:AppToken,
//     editType:editType,postId:sectionID,menuOrder:sectionMenuOrder})
  const apiData = dispatch(createNewSection({Name:sectionName,Description:sectionDescription,Skills:SkillsData,
    FAQs:FAQsData,parentEntityType:"Milestone",parentEntityId:mileStoneItem?.ID,
        childEntityType:"Section",childEntityId:sectionID,
  token:AppToken,courseId:postIdCourse ,postParent:mileStoneItem?.ID,userEmail:user_email?user_email:null,
  currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
  editType:editType,postId:sectionID,menuOrder:sectionMenuOrder}));
  /* get response as Promise   */
  apiData.then(response => {
    if(response){

    //   console.log(response)
      if(response?.section){
    setResponseMessage(response?.message);
    setSnackbarColor("rgba(144, 202, 249,1)");
  
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
  sendBackItem(response?.section);
  // console.log(response?.folder)
  setSectionID(response?.section?.ID);
  setSectionMenuOrder(response?.section?.menuOrder)
  setNewSectionPopUp(false);
},1000)
   }else{
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
   }
      
    // dispatch({
    //   type: "UPDATE_APP_TOKEN",
      
    //   payload:response?.course?.AppToken
    // });  
  //  console.log(response?.course);
 
   // 
   if(response?.logout){
    // pop up response?.logoutInfo
    //console.log(response?.logoutInfo)

    setResponseMessage("You are Logged Out!!!");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    setTimeout(()=>{
      dispatch({type:"LOGOUT"});

    },3000)
    
  }
/* resetting Login input Fields */

    }else{
      setResponseMessage("Something Went Wrong...");
      
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)    }

  }).catch(error => {
 
    //popup of error Info
    setResponseMessage("Something Went Wrong...");
      
    setSnackbarColor("#958FDA");
 
     
setLoader({status:false});

setSnackbarVisible(true);
setTimeout(()=>{
  
  setSnackbarVisible(false);
 
   
},3000)
    console.error(error);
  });
 
  }
  
     
const handleUpdateSection=(val)=>{
    let editType="",SkillsData="",FAQsData="";
    // console.log(sectionSkills)
    if(val=="editSection"){
      editType="editSection";
      SkillsData=JSON.stringify(sectionSkills);
      FAQsData=JSON.stringify(sectionFAQs);
     }
  setLoader({status:true});

//   console.log({Name:sectionName,Description:sectionDescription,Skills:SkillsData,
//         FAQs:FAQsData,
//         token:AppToken,courseId:postIdCourse ,postParent:mileStoneItem?.ID,userEmail:user_email?user_email:null,
//         currentToken:currentToken?currentToken:null,appToken:AppToken,
//         editType:editType,postId:sectionID,menuOrder:sectionMenuOrder})
      const apiData = dispatch(createNewSection({Name:sectionName,Description:sectionDescription,Skills:SkillsData,
        FAQs:FAQsData,parentEntityType:"Milestone",parentEntityId:mileStoneItem?.ID,
        childEntityType:"Section",childEntityId:sectionID,
      token:AppToken,courseId:postIdCourse ,postParent:mileStoneItem?.ID,userEmail:user_email?user_email:null,
      currentToken:currentToken?currentToken:null,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,
      editType:editType,postId:sectionID,menuOrder:sectionMenuOrder}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){

        // console.log(response)
        if(response?.section){
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
changeItemData(response?.section?.ID,response?.section);
    setSnackbarVisible(false);
    setSectionDescription(response?.section?.Description);
    setSectionID(response?.section?.ID);
    setNewSectionPopUp(false);
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }



    return (<>
    
   {/* {<Loading  Load={loader?.status}/>} */}
     {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
    {FolderLook==""?<div className="" style={{alignContent:"center",textAlign:"center",marginTop:"0px",
     
     transition: 'transform 2s ease, opacity 1s ease',
   }}> <div className="userInfoLinerName"> <h2>{!sectionItem?.ID?"Create Section "+sectionMenuOrder+"- Add Details ":"Edit Section "+sectionMenuOrder+" Details" }</h2></div>
    <div align="center" className="" style={{position:"absolute", top:"60px",bottom:"98px",right:"10px",left:"10px",
            overflowY:"auto"}}>
        
        
        
    <textarea onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave} className="createContentTextbox"  style= {{fontSize:"18px",width:"85%"}} 
        placeholder="Add Section Name" type="text"
     rows={2} name="courseTitle" value={sectionName} onChange={
        (e)=>setSectionName(e.target.value)
    
    
     } />
     
        
    <textarea onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave} className="createContentTextbox"  style= {{fontSize:"18px",width:"85%"}} 
        placeholder="Add Section Details" type="text"
     rows={5} name="courseTitle" value={sectionDescription} onChange={
        (e)=>setSectionDescription(e.target.value)
    
    
     } />
    <div style={{width:"90%"}}>
    {/* <AddHighlightsSection  data={[{}]} /> */}
    <AddSkillsSection  sendBackData={(data)=>{setSectionSkills(data);}} data={sectionSkills}/>
    </div>
    
    </div>
    <div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"30px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter} 
  onMouseLeave={handleMouseLeave} onClick={()=>{setNewSectionPopUp(false)}}  
  className=" CreateCourseStepsOuterRightButtonBackPopUp"  style={{background:"#666",border:"3px solid #666",color:"#fff",fontSize:"16px"}} type="submit"
  > Cancel </button>

{sectionID?<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{
    handleUpdateSection('editSection')
  
  }}   style={{width:"140px",height:"55px"}}
  className="CreateCourseStepsOuterRightButtonPopUp"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Click To  Create"} </button>:
 <button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{
    handleCreateSection()
  
  }}  style={{width:"140px",height:"55px"}}
  className="CreateCourseStepsOuterRightButtonPopUp"    type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Click To  Create"} </button>
 }
</div> 
   {/* <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
   <div  >   </div>
 
   
   <button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{setopenAppDesignPopUp()}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
    id="signupBtn"> Cancel </button>
{showAddFolderEdit?
<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleUpdateFolder("Description")}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Update"} </button>:
<button onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateFolder()}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
    id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Click To Create"} </button>}
 </div>  */}
 
 </div>
 
 :""}
       </>)
}
export default CreateSectionPopup;

